// project imports
import { ThemeMode } from 'config';
import getColors from 'utils/getColors';
import getShadow from 'utils/getShadow';

// ==============================|| OVERRIDES - INPUT BORDER & SHADOWS ||============================== //

function getColor({ variant, theme }) {
  const colors = getColors(theme, variant);
  const { light } = colors;

  const shadows = getShadow(theme, `${variant}`);

  return {
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: light },
    '&.Mui-focused': { boxShadow: shadows, '& .MuiOutlinedInput-notchedOutline': { border: '1px solid', borderColor: light } }
  };
}

// ==============================|| OVERRIDES - OUTLINED INPUT ||============================== //

export default function OutlinedInput(theme) {
  return {
    MuiOutlinedInput: {
      styleOverrides: {
        input: { padding: '0.59rem 0.744rem 0.49rem 0.64rem' }, // Reduced by -10% top, -15% right, -25% bottom, -15% left from 16px base, proportional to font size
        notchedOutline: {
          borderColor: theme.vars.palette.grey[300],
          // Keep notch gap in sync with InputLabel shrink scale (default MUI is 0.75em)
          '& legend': { fontSize: '0.875em' }
        },
        root: { 
          ...getColor({ variant: 'primary', theme }), 
          '&.Mui-error': { ...getColor({ variant: 'error', theme }) },
          '&.Mui-focused': {
            backgroundColor: theme.palette.grey[200]
          }
        },
        inputSizeSmall: { padding: '7.5px 8px 7.5px 12px' },
        inputMultiline: { padding: 0 },
        colorSecondary: getColor({ variant: 'secondary', theme }),
        colorError: getColor({ variant: 'error', theme }),
        colorWarning: getColor({ variant: 'warning', theme }),
        colorInfo: getColor({ variant: 'info', theme }),
        colorSuccess: getColor({ variant: 'success', theme })
      }
    }
  };
}
